module.exports = __webpack_public_path__ + "static/img/2.3d18402.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/downloadImg/2.png
// module id = 4iCN
// module chunks = 1